import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { config } from '../../../common/config'
import { getConfigBySite } from '../../../config/sites'
import EmptyResultsPlaceholder from '../../components/emptyResultsPlaceholder'
import HeroItemSection from '../../components/heroItemSection'
import ItemsGrid from '../../components/itemsGrid'
import LoadingCover from '../../components/loadingCover'
import PageContentSection from '../../components/pageContentSection'
import SearchPageContentWrapper from '../../components/searchPageContentWrapper'
import ThumbnailsSidebar from '../../components/thumbnailsSidebar'
import UsDollarsNoticeContainer from '../../components/usDollarsNotice/usDollarsNoticeContainer'
import VideoControlsContainer from '../../components/video/videoControlsContainer'
import { Props } from '../../containers/featurePageContainer'

import PageHeader from '../../components/pageHeader'

import * as styles from './featurePage.module.css'

const FeaturePage = (props: Props) => {
  const {
    featuredItems,
    featuredAuthors,
    location,
    experimentsReady,
    currentSite,
    isLoading,
    metadata
  } = props
  const hasItems = featuredItems && featuredItems.length > 0
  const firstItem = featuredItems[0]
  const restItems = featuredItems.slice(1)
  const firstItemViewType = getConfigBySite(
    currentSite,
    'ui.featured_hero_item_viewtype'
  )

  const shouldShowVideoControls = currentSite === Site.videohive

  const defaultAvatarImgSrc = `${
    config.assets.PUBLIC_PATH
  }/images/default-user.jpg`

  const featuredAuthorsThumbnails = featuredAuthors.map(author => ({
    imgSrc: author.profile_image_url || defaultAvatarImgSrc,
    link: author.profile_path,
    title: author.username
  }))
  return (
    <article>
      <PageHeader
        heading="Featured Files"
        subHeading={metadata ? metadata.sub_heading : ''}
        currentSite={currentSite}
        defaultBreadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Featured' }]}
      />

      <SearchPageContentWrapper
        experimentsReady={experimentsReady}
        currentSite={currentSite}
      >
        {isLoading && <LoadingCover />}
        {hasItems && (
          <div>
            <HeroItemSection
              item={firstItem}
              currentSite={currentSite}
              location={location}
              viewType={firstItemViewType}
            />
            <PageContentSection>
              <div className={styles.titleSection}>
                <h2 className={styles.subtitle}>
                  Items featured in the last 6 months
                </h2>
                <div className={styles.controls}>
                  <UsDollarsNoticeContainer />
                  {shouldShowVideoControls && <VideoControlsContainer />}
                </div>
              </div>
              <div className={styles.itemsGrid}>
                <ItemsGrid
                  items={restItems}
                  location={location}
                  listName="Featured files: Featured Items"
                />
                <div className={styles.sidebar}>
                  <ThumbnailsSidebar
                    title="Featured Authors"
                    thumbnails={featuredAuthorsThumbnails}
                  />
                </div>
              </div>
            </PageContentSection>
          </div>
        )}
        {!hasItems && (
          <EmptyResultsPlaceholder
            heading="Nothing exists here"
            subHeading="We couldn't find any data for this page. Please try again later."
          />
        )}
      </SearchPageContentWrapper>
    </article>
  )
}

export default FeaturePage
